import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants, FILE_UPLOAD_TIMEOUT, generateRandomString } from 'src/app/constants';
import { GridErrorWarningComponent } from 'src/app/core/dialogs/grid-error-warning/grid-error-warning.component';
import { ExportStateService } from 'src/app/service/export-state.service';
import { HomeService } from 'src/app/service/home.service';
import { ExcelService } from 'src/app/service/excel.service';
import { WebSocketService } from 'src/app/service/websocket.service';
import { environment } from 'src/environments/environment';
import { catchError, EMPTY, takeWhile, timeout } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false
})
export class HomeComponent implements OnInit {
  @ViewChild('fileInputSAP') fileInputSAP!: ElementRef<HTMLInputElement>;
  @ViewChild('fileInputSAPImp') fileInputSAPImp!: ElementRef<HTMLInputElement>;
  @ViewChild('fileInputASN') fileInputASN!: ElementRef<HTMLInputElement>;
  successMessage: string;
  errorMessage: string;
  asnExportFile
  sapVerificationFile
  sapImportFile
  dropAreaASNExport: any;
  dropAreaSAPVerification: any;
  dropAreaSAPImport: any;

  userID: number;
  asnExportShortFileName: string;
  sapVerificationShortFileName: string;
  sapImportShortFileName: string;
  asnExportShortFileName1: string;
  sapVerificationShortFileName1: string;
  sapImportShortFileName1: string; const_userid = "User ID Error"
  moduleType: string; const_select_file = "Please select the file first"
  isAccessible = false; const_upload_failed = 'Failed to upload file!'
  selectedFilePathforASN: any; const_upload_msg = 'Failed to upload file. Please re-upload the file.'
  selectedFilePathforSAP: any; const_export_asn = 'Export ASN'
  selectedFilePathforSAPImp: any; const_msg1 = 'An unexpected error occurred. Please retry. Contact IS Service Desk if error persists';
  constructor(private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly dialog: MatDialog, private readonly excelService: ExcelService, private readonly constants: Constants, private readonly homeService: HomeService,
    private readonly exportStateService: ExportStateService, private readonly webSocketService: WebSocketService) {

  }

  ngOnInit(): void {
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    this.dropAreaASNExport = document.querySelector(".dropareaZoneASNExport")
    if (this.dropAreaASNExport) {
      this.dropAreaASNExport.addEventListener("dragover", (event) => {
        event.preventDefault();
      });
      this.dropAreaASNExport.addEventListener("dragleave", (event) => {
        event.preventDefault();
      });
      this.dropAreaASNExport.addEventListener("drop", (event) => {
        event.preventDefault();
        this.fileChange('ASNExport', event.dataTransfer.files[0]);
      });
    }
    this.dropAreaSAPVerification = document.querySelector(".dropareaZoneSAPVerification")
    if (this.dropAreaSAPVerification) {
      this.dropAreaSAPVerification.addEventListener("dragover", (event) => {
        event.preventDefault();
      });
      this.dropAreaSAPVerification.addEventListener("dragleave", (event) => {
        event.preventDefault();
      });
      this.dropAreaSAPVerification.addEventListener("drop", (event) => {
        event.preventDefault();
        this.fileChange('SAPVerification', event.dataTransfer.files[0]);
      });

    }
    this.dropAreaSAPImport = document.querySelector(".dropareaZoneSAPImport")
    if (this.dropAreaSAPImport) {
      if (this.dropAreaSAPImport) {
        this.dropAreaSAPImport.addEventListener("dragover", (event) => {
          event.preventDefault();
        });
        this.dropAreaSAPImport.addEventListener("dragleave", (event) => {
          event.preventDefault();
        });
        this.dropAreaSAPImport.addEventListener("drop", (event) => {
          event.preventDefault();
          this.fileChange('SAPImport', event.dataTransfer.files[0]);
        });
      }
    }
    // this.checkRoles();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }


  async checkRoles() {
    await this.exportStateService.getRoles();
    const roles = this.exportStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_NAMCPlanner60EXP)) {

    //   this.isAccessible = true;
    // } else {
    //   window.location.replace(this.constants.LIOSMainPortalURL);
    // } // Commented for APM
  }

  reload(): void {
    this.sapImportShortFileName = null;
    this.sapVerificationShortFileName = null;
    this.asnExportShortFileName = null;



  }
  fileChange(type: string, event): void { // NOSONAR
    this.moduleType = type;
    const file = event.target.files.item(0);
    if (file != null) { // NOSONAR
      const extension = file.name.split('.').pop().toLowerCase();

      const allowed = ['xls', 'xlsx', 'csv'];
      if (allowed.indexOf(extension) == -1) { // NOSONAR
        this.asnExportFile = null;
        this.errorMessage = "File must be a type of spreadsheet.";
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);

      } else if (type == 'ASNExport') { // NOSONAR
        this.asnExportFile = event;
        this.asnExportShortFileName = file.name
        if (file.name.split('.').shift().length > 25) {
          this.asnExportShortFileName = file.name.split(".")
          this.asnExportShortFileName = this.asnExportShortFileName[0].substring(0, 25).trim() + '....' + this.asnExportShortFileName[1];
        }
      } else if (type == 'SAPVerification') { // NOSONAR
        this.sapVerificationFile = event;
        this.sapVerificationShortFileName = file.name
        if (file.name.split('.').shift().length > 25) {
          this.sapVerificationShortFileName = file.name.split(".")
          this.sapVerificationShortFileName = this.sapVerificationShortFileName[0].substring(0, 25).trim() + '....' + this.sapVerificationShortFileName[1];
        }
      } else if (type == 'SAPImport') { // NOSONAR
        this.sapImportFile = event;
        this.sapImportShortFileName = file.name
        if (file.name.split('.').shift().length > 25) {
          this.sapImportShortFileName = file.name.split(".")
          this.sapImportShortFileName = this.sapImportShortFileName[0].substring(0, 25).trim() + '....' + this.sapImportShortFileName[1];
        }
      }
    }
  }



 onFileSelected(type: string, event): void { // NOSONAR
  this.moduleType = type;
  const file = event.target.files.item(0);
  if (file != null) { // NOSONAR
    const extension = file.name.split('.').pop().toLowerCase();

    const allowed = ['xls', 'xlsx', 'csv'];
    if (allowed.indexOf(extension) == -1) { // NOSONAR
      this.asnExportFile = null;
      this.errorMessage = "File must be a type of spreadsheet.";
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTimeShort);

    } else if (type == 'ASNExport') { // NOSONAR
      this.asnExportFile = event;
      this.asnExportShortFileName = file.name
      this.asnExportShortFileName1 = file.name
      console.info(this.asnExportShortFileName1, "asnExportShortFileName1")

      if (file.name.split('.').shift().length > 25) {
        this.asnExportShortFileName = file.name.split(".")
        this.asnExportShortFileName = this.asnExportShortFileName[0].substring(0, 25).trim() + '....' + this.asnExportShortFileName[1];
      }

      // const parsedFileName = this.asnExportShortFileName
      //   ?.replace(/\s+/g, '_') // Replace spaces with underscore
      //   ?.replace(/[^a-zA-Z0-9._]/g, '_'); // Replace all non-alphanumeric/safe characters with underscore
      // this.asnExportShortFileName = `${generateRandomString()}_${parsedFileName}`;

      let originalName = this.asnExportShortFileName;

      // split name + extension
      const namePartsASN = originalName.split('.');
      const extASN = namePartsASN.pop()?.toLowerCase(); // force lowercase
      const baseNameASN = namePartsASN.join('.');
      const normalizedNameASN = `${baseNameASN}.${extASN}`;
      const parsedFileNameASN = normalizedNameASN
        ?.replace(/\s+/g, '_')
        ?.replace(/[^a-zA-Z0-9._]/g, '_');

      this.asnExportShortFileName = `${generateRandomString()}_${parsedFileNameASN}`;
      this.selectedFilePathforASN = `EXPORT/ASN/${this.asnExportShortFileName}`

    } else if (type == 'SAPVerification') { // NOSONAR
      this.sapVerificationFile = event;
      this.sapVerificationShortFileName = file.name
      this.sapVerificationShortFileName1 = file.name

      if (file.name.split('.').shift().length > 25) {
        this.sapVerificationShortFileName = file.name.split(".")
        this.sapVerificationShortFileName = this.sapVerificationShortFileName[0].substring(0, 25).trim() + '....' + this.sapVerificationShortFileName[1];
      }

      // const parsedFileName = this.sapVerificationShortFileName
      //   ?.replace(/\s+/g, '_') // Replace spaces with underscore
      //   ?.replace(/[^a-zA-Z0-9._]/g, '_'); // Replace all non-alphanumeric/safe characters with underscore
      // this.sapVerificationShortFileName = `${generateRandomString()}_${parsedFileName}`;

      let originalName1 = this.sapVerificationShortFileName;

      // split name + extension
      const namePartsSAPVer = originalName1.split('.');
      const extSAPVer = namePartsSAPVer.pop()?.toLowerCase(); // force lowercase
      const baseNameSAPVer = namePartsSAPVer.join('.');

      // rebuild filename
      const normalizedNameSAPVer = `${baseNameSAPVer}.${extSAPVer}`;

      const parsedFileNameSAPVer = normalizedNameSAPVer
        ?.replace(/\s+/g, '_')
        ?.replace(/[^a-zA-Z0-9._]/g, '_');

      this.sapVerificationShortFileName = `${generateRandomString()}_${parsedFileNameSAPVer}`;
      this.selectedFilePathforSAP = `EXPORT/SAPVerification/${this.sapVerificationShortFileName}`

    } else if (type == 'SAPImport') {  // NOSONAR
      this.sapImportFile = event;
      this.sapImportShortFileName = file.name
      this.sapImportShortFileName1 = file.name

      if (file.name.split('.').shift().length > 25) {
        this.sapImportShortFileName = file.name.split(".")
        this.sapImportShortFileName = this.sapImportShortFileName[0].substring(0, 25).trim() + '....' + this.sapImportShortFileName[1];
      }

      // const parsedFileName = this.sapImportShortFileName
      //   ?.replace(/\s+/g, '_') // Replace spaces with underscore
      //   ?.replace(/[^a-zA-Z0-9._]/g, '_'); // Replace all non-alphanumeric/safe characters with underscore
      // this.sapImportShortFileName = `${generateRandomString()}_${parsedFileName}`;

      let originalName2 = this.sapImportShortFileName;

      // split name + extension
      const namePartsSAPImp = originalName2.split('.');
      const extSAPImp = namePartsSAPImp.pop()?.toLowerCase(); // force lowercase
      const baseNameSAPImp = namePartsSAPImp.join('.');

      // rebuild filename
      const normalizedNameSAPImp = `${baseNameSAPImp}.${extSAPImp}`;

      const parsedFileNameSAPImp = normalizedNameSAPImp
        ?.replace(/\s+/g, '_')
        ?.replace(/[^a-zA-Z0-9._]/g, '_');

      this.sapImportShortFileName = `${generateRandomString()}_${parsedFileNameSAPImp}`;
      this.selectedFilePathforSAPImp = `EXPORT/SAPImport/${this.sapImportShortFileName}`
    }
  }
}

  uploadASNExport() {

    if (this.asnExportShortFileName) {
      const userData = sessionStorage?.getItem('FGA');
      if (userData) {
        this.userID = JSON.parse(userData)?.user?.userPrincipalName;
      }
      if (this.userID == undefined || this.userID == null) { // NOSONAR
        this.errorMessage = this.const_userid;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        return;
      }

      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      this.homeService.uploadExcelFileASNExport(this.userID, this.asnExportFile.target.files.item(0)).subscribe(
        response => {
          const tempResponse = JSON.parse(response)
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (tempResponse.length > 0) {
            if (tempResponse[0].row == null) {
              this.errorMessage = tempResponse[0].message;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTimeShort)
            } else { this.displayRecievedAPIResponse(`Export ASN - ${this.constants.FileValidation}`, "ERROR", tempResponse) }
          } else {
            this.asnExportFile.target.value = '';
            this.asnExportShortFileName = null;

            this.successMessage = this.constants.FileUploaded;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTimeShort);
          }

        }, _error => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.errorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTimeShort);
        });
    } else {
      this.errorMessage = this.const_select_file;
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTimeShort);
    }


  }

  async newuploadASNExport() {

    if (this.asnExportShortFileName) {
      const userData = sessionStorage?.getItem('FGA');
      if (userData) {
        this.userID = JSON.parse(userData)?.user?.userPrincipalName;
      }
      if (this.userID == undefined || this.userID == null) {  // NOSONAR
        this.errorMessage = this.const_userid;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        return;
      }
      this.errorMessage = ''
      this.successMessage = ''
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      try {
        this.webSocketService.connect();
        await this.webSocketService.waitUntilSocketConnected();
        console.info(
          'WebSocket connected:1',
          this.webSocketService.isSocketConnected()
        );
        this.webSocketService.sendMessage(
          // JSON.stringify({
          { fileName: this.selectedFilePathforASN }
          // })
        );
        const url = `${environment.FILE_UPLOAD_URI}/${this.selectedFilePathforASN}`;
        const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
        const upn = fgaDetails?.user?.userPrincipalName;

        const uploadHeaders: any = {
          'Content-Type': this.asnExportFile.target.files.item(0)?.type, // Set file content type
          'x-amz-meta-authtoken': sessionStorage.getItem('accessToken'),
          'x-amz-meta-userid': upn,
          'x-auth-token': sessionStorage.getItem('accessToken')

        };

        const response = await fetch(url, {
          method: 'PUT',
          headers: uploadHeaders,
          body: this.asnExportFile.target.files.item(0),
        });

        if (!response.ok) {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent);; // 🛑 Stop spinner on error
          this.errorMessage = this.const_upload_failed;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTimeShort);
          this.webSocketService.closeConnection();
          return;
        }

        this.webSocketService
          .receiveMessages()
          .pipe(
            // If no message is received within 25 seconds, throw TimeoutError
            timeout({
              each: FILE_UPLOAD_TIMEOUT, // 25 seconds between messages
            }),
            takeWhile( (msg) => msg.status != 'success' && msg.status != 'failed' && msg.status != 'error', true ), // NOSONAR
            catchError((err) => {
              if (err.name == 'TimeoutError') {  // NOSONAR
                console.info(
                  `No message received in ${FILE_UPLOAD_TIMEOUT / 1000
                  } seconds. Closing connection.`
                );
                this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
                this.webSocketService.closeConnection();
                this.errorMessage = this.const_upload_msg;
                setTimeout(() => {
                  this.successMessage = "";
                  this.errorMessage = "";
                }, this.constants.notificationMessageTimeShort);

              } else {
                console.info('WebSocket error:1', err);
              }
              return EMPTY; // Stop further emissions
            })
          )
          .subscribe((messages) => {
            console.info(messages, "messages from Lambda1");
            const status = messages?.status
            const backendResp = messages?.backendResponse;
            try {
              if (backendResp) {
                // Check backend API response for success/failure
                if (status) {
                  this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
                  const tempResponse = backendResp
                  if (tempResponse.length > 0) {
                    if (tempResponse[0].row == null) {  // NOSONAR
                      this.errorMessage = tempResponse[0].message;
                      setTimeout(() => {
                        this.successMessage = "";
                        this.errorMessage = "";
                      }, this.constants.notificationMessageTimeShort)
                    } else { this.displayRecievedAPIResponse(`Export ASN - ${this.constants.FileValidation}`, "ERROR", tempResponse) }
                    this.sendmail('error', this.const_export_asn, this.const_export_asn, this.asnExportShortFileName1)
                  } else if (tempResponse.length == 0) {  // NOSONAR

                    this.asnExportFile.target.value = '';
                    this.asnExportShortFileName = null;

                    this.successMessage = this.constants.FileUploaded;
                    setTimeout(() => {
                      this.successMessage = "";
                      this.errorMessage = "";
                    }, this.constants.notificationMessageTimeShort);
                    this.sendmail('success', this.const_export_asn, this.const_export_asn, this.asnExportShortFileName1)
                  }
                  else {
                    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
                    this.errorMessage = this.constants.failedFileUpload;
                    setTimeout(() => {
                      this.successMessage = "";
                      this.errorMessage = "";
                    }, this.constants.notificationMessageTimeShort);
                    this.webSocketService.closeConnection();
                    this.sendmail('error', this.const_export_asn, this.const_export_asn, this.asnExportShortFileName1)
                  }
                }
                else {
                  this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
                  this.errorMessage = backendResp?.error
                  setTimeout(() => {
                    this.successMessage = "";
                    this.errorMessage = "";
                  }, this.constants.notificationMessageTimeShort);
                  this.sendmail('error', this.const_export_asn, this.const_export_asn, this.asnExportShortFileName1)
                }

                this.webSocketService.closeConnection();

              }

            }
            catch {
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
              this.errorMessage = this.constants.APIErrorMessage;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTimeShort);
              this.webSocketService.closeConnection();
              this.sendmail('error', this.const_export_asn, this.const_export_asn, this.asnExportShortFileName1)
            }


          })
      } catch (err) {
        console.info('Unexpected upload exception:', err);
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.webSocketService.closeConnection();
        this.errorMessage = this.const_msg1;
        this.asnExportFile.target.value = '';
        this.asnExportShortFileName = null;

        this.fileInputASN.nativeElement.value = ''
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        this.sendmail('error', this.const_export_asn, this.const_export_asn, this.asnExportShortFileName1)
      }

    } else {
      this.errorMessage = this.const_select_file;
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTimeShort);
      this.sendmail('error', this.const_export_asn, this.const_export_asn, this.asnExportShortFileName1)
    }


  }

  uploadSAPImport() {

    if (this.sapImportShortFileName) {

      const userData = sessionStorage?.getItem('FGA');
      if (userData) {
        this.userID = JSON.parse(userData)?.user?.userPrincipalName;
      }
      if (this.userID == undefined || this.userID == null) {  // NOSONAR
        this.errorMessage = this.const_userid;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        return;
      }

      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      this.homeService.uploadExcelFileSAPImport(this.userID, this.sapImportFile.target.files.item(0)).subscribe(
        response => {
          const tempResponse = JSON.parse(response)
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (tempResponse.length == 1) { // NOSONAR
            this.errorMessage = tempResponse[0].message;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTimeLong);
          } else if (tempResponse.length > 0) {
            this.displayRecievedAPIResponse(`SAP Import - ${this.constants.FileValidation}`, "ERROR", tempResponse)
          } else {
            this.sapImportFile.target.value = '';
            this.sapImportShortFileName = null;

            this.successMessage = this.constants.FileUploaded;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTimeShort);
          }


        }, _error => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.errorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTimeShort);
        });
    } else {
      this.errorMessage = this.const_select_file;
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTimeShort);
    }


  }

  async newuploadSAPImport() {

    if (this.sapImportShortFileName) {

      const userData = sessionStorage?.getItem('FGA');
      if (userData) {
        this.userID = JSON.parse(userData)?.user?.userPrincipalName;
      }
      if (this.userID == undefined || this.userID == null) { // NOSONAR
        this.errorMessage = this.const_userid;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        return;
      }

      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      try {
        this.webSocketService.connect();
        await this.webSocketService.waitUntilSocketConnected();
        console.info(
          'WebSocket connected:',
          this.webSocketService.isSocketConnected()
        );
        this.webSocketService.sendMessage(
          // JSON.stringify({
          { fileName: this.selectedFilePathforSAPImp }
          // })
        );
        const url = `${environment.FILE_UPLOAD_URI}/${this.selectedFilePathforSAPImp}`;
        const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
        const upn = fgaDetails?.user?.userPrincipalName;

        const uploadHeaders: any = {
          'Content-Type': this.sapImportFile.target.files.item(0)?.type, // Set file content type
          'x-amz-meta-authtoken': sessionStorage.getItem('accessToken'),
          'x-amz-meta-userid': upn,
          'x-auth-token': sessionStorage.getItem('accessToken')

        };

        const response = await fetch(url, {
          method: 'PUT',
          headers: uploadHeaders,
          body: this.sapImportFile.target.files.item(0),
        });

        if (!response.ok) {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent);; // 🛑 Stop spinner on error
          this.errorMessage = this.const_upload_failed;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTimeShort);
          this.webSocketService.closeConnection();
          return;
        }

        this.webSocketService
          .receiveMessages()
          .pipe(
            // If no message is received within 25 seconds, throw TimeoutError
            timeout({
              each: FILE_UPLOAD_TIMEOUT, // 25 seconds between messages
            }),
            takeWhile( (msg) => msg.status != 'success' && msg.status != 'failed' && msg.status != 'error', true ), // NOSONAR
            catchError((err) => {
              if (err.name == 'TimeoutError') { // NOSONAR
                console.info(
                  `No message received in ${FILE_UPLOAD_TIMEOUT / 1000
                  } seconds. Closing connection.`
                );
                this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
                this.webSocketService.closeConnection();
                this.errorMessage = this.const_upload_msg;
                setTimeout(() => {
                  this.successMessage = "";
                  this.errorMessage = "";
                }, this.constants.notificationMessageTimeShort);

              } else {
                console.info('WebSocket error:3', err);
              }
              return EMPTY; // Stop further emissions
            })
          )
          .subscribe((messages) => {
            console.info(messages, "messages from Lambda");

            const backendResp = messages.backendResponse;
            const status = messages?.status

            try {
              if (backendResp) {
                this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
                if (status) {
                  const tempResponse = backendResp
                  if (tempResponse.length == 1) { // NOSONAR
                    this.errorMessage = tempResponse[0].message;
                    setTimeout(() => {
                      this.successMessage = "";
                      this.errorMessage = "";
                    }, this.constants.notificationMessageTimeLong);
                    this.sendmail('error', 'Run SAP', 'SAP', this.sapImportShortFileName1)
                  } else if (tempResponse.length > 0) {
                    this.displayRecievedAPIResponse(`SAP Import - ${this.constants.FileValidation}`, "ERROR", tempResponse)
                    this.sendmail('error', 'Run SAP', 'SAP', this.sapImportShortFileName1)
                  } else if (tempResponse.length == 0) { // NOSONAR
                    this.sapImportFile.target.value = '';
                    this.sapImportShortFileName = null;

                    this.successMessage = this.constants.FileUploaded;
                    setTimeout(() => {
                      this.successMessage = "";
                      this.errorMessage = "";
                    }, this.constants.notificationMessageTimeShort);
                    this.sendmail('success', 'Run SAP', 'SAP', this.sapImportShortFileName1)
                  }
                  else {
                    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
                    this.errorMessage = this.constants.failedFileUpload;
                    setTimeout(() => {
                      this.successMessage = "";
                      this.errorMessage = "";
                    }, this.constants.notificationMessageTimeShort);
                    this.webSocketService.closeConnection();
                    this.sendmail('error', 'Run SAP', 'SAP', this.sapImportShortFileName1)
                  }


                }
                else {
                  this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
                  this.errorMessage = backendResp?.error
                  setTimeout(() => {
                    this.successMessage = "";
                    this.errorMessage = "";
                  }, this.constants.notificationMessageTimeShort);
                  this.sendmail('error', 'Run SAP', 'SAP', this.sapImportShortFileName1)
                }

                this.webSocketService.closeConnection();


              }
            }
            catch {
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
              this.errorMessage = this.constants.APIErrorMessage;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTimeShort);
              this.webSocketService.closeConnection();
              this.sendmail('error', 'Run SAP', 'SAP', this.sapImportShortFileName1)
            }



          })
      } catch (err) {
        console.info('Unexpected upload exception1:', err);
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.webSocketService.closeConnection();
        this.errorMessage = this.const_msg1;
        this.sapImportFile.target.value = '';
        this.sapImportShortFileName = null;

        this.fileInputSAPImp.nativeElement.value = ''
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        this.sendmail('error', 'Run SAP', 'SAP', this.sapImportShortFileName1)
      }
    } else {
      this.errorMessage = this.const_select_file;
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTimeShort);
      this.sendmail('error', 'Run SAP', 'SAP', this.sapImportShortFileName1)
    }


  }

  uploadSAPVerification() {

    if (this.sapVerificationShortFileName) {

      const userData = sessionStorage?.getItem('FGA');
      if (userData) {
        this.userID = JSON.parse(userData)?.user?.userPrincipalName;
      }
      if (this.userID == undefined || this.userID == null) { // NOSONAR
        this.errorMessage = this.const_userid;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        return;
      }

      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      this.homeService.uploadExcelFileSAPVerification(this.userID, this.sapVerificationFile.target.files.item(0)).subscribe(
        response => {
          const tempResponse = JSON.parse(response)
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (tempResponse.length > 0) {
            if (tempResponse.length == 1) { // NOSONAR
              this.errorMessage = tempResponse[0].message;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTimeLong);
            } else if (Object.keys(tempResponse[0]).length == 5) { // NOSONAR
              this.displayRecievedAPIResponse(`SAP Verification - ${this.constants.FileValidation}`, "ERROR", tempResponse)
            } else if (Object.keys(tempResponse[0]).length > 5) {
              this.sapVerificationFile.target.value = '';
              this.sapVerificationShortFileName = null;
              this.sapVerificationShortFileName1 = null
              this.displayRecievedAPIResponse("SAP Verification - Success", "SUCCESS", tempResponse)
            }
          } else {
            this.errorMessage = this.constants.APIErrorMessage;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTimeShort);
          }

        }, error => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          console.info(error.response)
          this.errorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTimeShort);
        });
    } else {
      this.errorMessage = this.const_select_file;
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTimeShort);
    }


  }

  async newuploadSAPVerification() {

    if (this.sapVerificationShortFileName) {

      const userData = sessionStorage?.getItem('FGA');
      if (userData) {
        this.userID = JSON.parse(userData)?.user?.userPrincipalName;
      }
      if (this.userID == undefined || this.userID == null) { // NOSONAR
        this.errorMessage = this.const_userid;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        return;
      }

      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      try {
        this.webSocketService.connect();
        await this.webSocketService.waitUntilSocketConnected();
        console.info(
          'WebSocket connected:2',
          this.webSocketService.isSocketConnected()
        );
        this.webSocketService.sendMessage(
          // JSON.stringify({
          { fileName: this.selectedFilePathforSAP }
          // })
        );
        const url = `${environment.FILE_UPLOAD_URI}/${this.selectedFilePathforSAP}`;
        const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
        const upn = fgaDetails?.user?.userPrincipalName;

        const uploadHeaders: any = {
          'Content-Type': this.sapVerificationFile.target.files.item(0)?.type, // Set file content type
          'x-amz-meta-authtoken': sessionStorage.getItem('accessToken'),
          'x-amz-meta-userid': upn,
          'x-auth-token': sessionStorage.getItem('accessToken')

        };

        const response = await fetch(url, {
          method: 'PUT',
          headers: uploadHeaders,
          body: this.sapVerificationFile.target.files.item(0),
        });

        if (!response.ok) {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent);; // 🛑 Stop spinner on error
          this.errorMessage = this.const_upload_failed;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTimeShort);
          this.webSocketService.closeConnection();
          return;
        }

        this.webSocketService
          .receiveMessages()
          .pipe(
            // If no message is received within 25 seconds, throw TimeoutError
            timeout({
              each: FILE_UPLOAD_TIMEOUT, // 25 seconds between messages
            }),
            takeWhile( (msg) => msg.status != 'success' && msg.status != 'failed' && msg.status != 'error', true ), // NOSONAR
            catchError((err) => { 
              if (err.name == 'TimeoutError') { // NOSONAR
                console.info(
                  `No message received in ${FILE_UPLOAD_TIMEOUT / 1000
                  } seconds. Closing connection.`
                );
                this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
                this.webSocketService.closeConnection();
                this.errorMessage = this.const_upload_msg;
                setTimeout(() => {
                  this.successMessage = "";
                  this.errorMessage = "";
                }, this.constants.notificationMessageTimeShort);

              } else {
                console.info('WebSocket error:2', err);
              }
              return EMPTY; // Stop further emissions
            })
          )
          .subscribe((messages) => {
            console.info(messages, "messages from Lambda2");

            const backendResp = messages.backendResponse;
            const status = messages.status
            try {

              if (backendResp) {
                // Check backend API response for success/failure
                this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
                if (status) {
                  const tempResponse = backendResp
                  if (tempResponse.length > 0) {
                    if (tempResponse.length == 1) { // NOSONAR
                      this.errorMessage = tempResponse[0].message;
                      setTimeout(() => {
                        this.successMessage = "";
                        this.errorMessage = "";
                      }, this.constants.notificationMessageTimeLong);
                    } else if (Object.keys(tempResponse[0]).length == 5) { // NOSONAR
                      this.displayRecievedAPIResponse(`SAP Verification - ${this.constants.FileValidation}`, "ERROR", tempResponse)
                    } else if (Object.keys(tempResponse[0]).length > 5) {
                      this.sapVerificationFile.target.value = '';
                      this.sapVerificationShortFileName = null;
                      this.sapVerificationShortFileName1 = null
                      this.displayRecievedAPIResponse("SAP Verification - Success", "SUCCESS", tempResponse)
                    }
                  }
                  else {
                    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
                    this.errorMessage = this.constants.failedFileUpload;
                    setTimeout(() => {
                      this.successMessage = "";
                      this.errorMessage = "";
                    }, this.constants.notificationMessageTimeShort);
                  }
                } else {
                  this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
                  this.errorMessage = backendResp?.error
                  setTimeout(() => {
                    this.successMessage = "";
                    this.errorMessage = "";
                  }, this.constants.notificationMessageTimeShort);
                }

                this.webSocketService.closeConnection();

              }
            }
            catch {
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
              this.errorMessage = this.constants.APIErrorMessage;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTimeShort);
            }



          })
      } catch (err) {
        console.info('Unexpected upload exception3:', err);
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.webSocketService.closeConnection();
        this.errorMessage = this.const_msg1;
        this.sapVerificationFile.target.value = '';
        this.sapVerificationShortFileName = null;
        this.sapVerificationShortFileName1 = null
        this.fileInputSAP.nativeElement.value = ''
      }
    } else {
      this.errorMessage = this.const_select_file;
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTimeShort);
    }


  }
  displayRecievedAPIResponse(header, eventType, displayData) {
    const dialogRef = this.dialog.open(
      GridErrorWarningComponent, {
      disableClose: true,
      width: '1100px',
      height: '450px',
      data: {
        header: header,
        eventType: eventType,
        displayRowData: displayData
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'CloseEvent') { // NOSONAR
        // do something 
      }
    });
  }

  reportAsnSheet() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    const userData = sessionStorage?.getItem('FGA');
    if (userData) {
      this.userID = JSON.parse(userData)?.user?.userPrincipalName;
    }
    this.homeService.downloadReport(this.userID).subscribe(
      response => {
        const headers = ['Supplier', 'Invoice', 'Shipment Date', 'PO', 'Line', 'Schedule', 'BA#', 'Quantity', 'KG'];
        const exportData = [];

        const res: any = response
        res.forEach(e => {
          const obj = {
            supplier: e.supplier,
            invoice: e.invoiceNum,
            shipDate: e.shipmentDate,
            po: e.po,
            line: e.poLine,
            schedule: e.poSchedule,
            ba: e.backNum,
            quantity: e.qty,
            kg: e.kg
          };
          exportData.push(obj);
        });
        this.excelService.exportAsExcelFile(exportData, 'REPORT-ASN', headers);

        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)


      }, _error => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.errorMessage = this.constants.APIErrorMessage;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);

      }
    )
  }

  sendmail(result, filename, filename1, realfilename) {
    const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    const upn = fgaDetails?.user?.userPrincipalName;
    let subject = ''
    let content = ''
    if (result == 'success') { // NOSONAR
      subject = `${filename} file import completed Successfully`
      content = `${filename1} file import completed Successfully for file - ${realfilename}.\n\nThanks and Regards`
    }
    else {
      subject = `${filename} file import Failed`
      content = `${filename1} file import failed for file - ${realfilename}. Please validate the ${realfilename} file and retry import.\nContact IS Service Desk if error persists with a valid file. \n\nThanks and Regards`
    }
    const payload = {
      fromList: ["tmna-it-lios-donotreply@toyota.com"],
      recipientList: [{ "type": "USER", "mailId": `${upn}`, "category": "TO" }],
      subject: subject,
      content: content
    }
    this.homeService.sendMail(payload).subscribe({
      next: (res: any) => {
        console.info('res ', res);
        if (res.status == 200) { // NOSONAR
          console.info('Email send successfully')
        } else {
          console.info('Failed to  send Email')
        }
      },
      error: (_err: any) => {
        console.info('sendMail Error:', _err);
      },
    });
  }
}
